import axios from "@/api/axios";
import qs from "qs";

const getList = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    managerlistcnt: "0",
    managerlist: [],
  };
  const options = {
    method: "GET",
    url: "/manager/adminlist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    params: {
      pageno: params.pageno,
    },
    //params: params
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(null);
    }
  });
};

const getView = async (adminno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    admininfo: [
      {
        name: "",
        id: "",
        part: "",
        position: "",
        phone: "",
        mail: "",
        regdate: "",
        status: "",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/manager/adminview/" + adminno,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const setManager = async (form, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/manager/adminwrite",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(form),
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};
const modiManager = async (form, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/manager/adminwrite/" + form.adminno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(form),
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const getTimezoneList = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    listcnt: "0",
    list: [],
  };
  const options = {
    method: "GET",
    url: "/manager/timezonelist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(params),
    //params: params
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(null);
    }
  });
};

const getTimezoneView = async (timezone_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    info: [],
  };
  const options = {
    method: "GET",
    url: "/manager/timezoneview/" + timezone_pk,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const setTimezone = async (form, timezone_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  let url = "";
  if (timezone_pk) url = "/manager/timezonewrite/" + timezone_pk;
  else url = "/manager/timezonewrite";
  const options = {
    method: "POST",
    url: url,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(form),
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const getTimezonedstList = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    listcnt: "0",
    list: [],
  };
  const options = {
    method: "GET",
    url: "/manager/timezonedstList",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(params),
    //params: params
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(null);
    }
  });
};

const getTimezonedstView = async (timezonedst_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    info: [],
  };
  const options = {
    method: "GET",
    url: "/manager/timezonedstview/" + timezonedst_pk,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const setTimezonedst = async (form, timezonedst_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  let url = "";
  if (timezonedst_pk) url = "/manager/timezonedstwrite/" + timezonedst_pk;
  else url = "/manager/timezonedstwrite";

  const options = {
    method: "POST",
    url: url,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(form),
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

// 타임존리스트(주)
const get_timezonelist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    stateslistcnt: 0,
    stateslist: [],
  };

  const options = {
    method: "GET",
    url: "/common/timezonelist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_timezonelist", err);
    result(false, err);
  }
};

// 국가리스트
const get_countrylist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    countrylistcnt: 0,
    countrylist: [],
  };

  const options = {
    method: "GET",
    url: "/common/countrylist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_countrylist", err);
    result(false, err);
  }
};

// 지역리스트(주)
const get_stateslist = async (countryno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    stateslistcnt: 0,
    stateslist: [],
  };

  const options = {
    method: "GET",
    url: "/common/stateslist/" + countryno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_stateslist", err);
    result(false, err);
  }
};

const get_badgelist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    list: [],
  };

  const options = {
    method: "GET",
    url: "/manager/badgelist",
    params: {
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_badgelist", err);
    result(false, err);
  }
};

const delete_badge = async (badge_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/badgedrop/" + badge_pk,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("delete_badge", err);
    result(false, err);
  }
};

const set_badge = async (form, badge_pk, result) => {
  const data = new FormData();

  for (let key in form) {
    data.append(key, form[key]);
  }

  let finalData = {
    code: 200,
    message: "Ok",
  };

  let url = "";
  if (badge_pk) url = "/manager/badgewrite/" + badge_pk;
  else url = "/manager/badgewrite";

  const options = {
    method: "POST",
    url: url,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: data,
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const get_badgeview = async (badge_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    badgeinfo: [
      {
        title: "",
        grade: "",
        filename: "",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/manager/badgeview/" + badge_pk,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_badgeview", err);
    result(false, err);
  }
};

const get_xpointlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    list: [],
  };

  const options = {
    method: "GET",
    url: "/manager/xpointlist",
    params: {
      xpoint_type: params.xpoint_type,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_xpointlist", err);
    result(false, err);
  }
};

const delete_xpoint = async (xpoint_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/xpointdrop/" + xpoint_pk,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("delete_xpoint", err);
    result(false, err);
  }
};

const set_xpoint = async (form, xpoint_pk, result) => {
  const data = new FormData();

  for (let key in form) {
    data.append(key, form[key]);
  }

  let finalData = {
    code: 200,
    message: "Ok",
  };

  let url = "";
  if (xpoint_pk) url = "/manager/xpointwrite/" + xpoint_pk;
  else url = "/manager/xpointwrite";

  const options = {
    method: "POST",
    url: url,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: data,
    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const get_xpointview = async (xpoint_pk, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    xpointinfo: [
      {
        title: "",
        grade: "",
        filename: "",
      },
    ],
  };
  const options = {
    method: "GET",
    url: "/manager/xpointview/" + xpoint_pk,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_xpointview", err);
    result(false, err);
  }
};

const get_paymentlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    list: [],
  };

  const options = {
    method: "GET",
    url: "/manager/paymentlist",
    params: {
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_badgelist", err);
    result(false, err);
  }
};

const post_paymentrefund = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "POST",
    url: "/postact/paymentrefund/" + params.tod_pk,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},

    // params: {}
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const get_bannerlist = async (result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    listcnt: 0,
    list: [],
  };

  const options = {
    method: "GET",
    url: "/manager/bannerlist",
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_bannerlist", err);
    result(false, err);
  }
};

const post_bannerwrite = async (form, result) => {
  const data = new FormData();

  form.forEach((item, idx) => {
    for (let key in item) {
      if (key === "filename") {
        if (item[key]) {
          data.append(`file[${idx}]`, item[key]);
        }
      } else {
        data.append(`form[${idx}][${key}]`, item[key] != null ? item[key] : "");
      }
    }
  });

  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/manager/bannerwrite",
    data: data,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = response.data;
        result(true, finalData);
      } else {
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("post_bannerwrite", err);
    result(false, { message: "네트워크 오류가 발생했습니다." });
  }
};

export default {
  getList,
  getView,
  setManager,
  modiManager,
  getTimezoneList,
  getTimezoneView,
  setTimezone,
  getTimezonedstList,
  getTimezonedstView,
  setTimezonedst,
  get_timezonelist,
  get_stateslist,
  get_countrylist,
  get_badgelist,
  delete_badge,
  set_badge,
  get_badgeview,
  get_xpointlist,
  delete_xpoint,
  set_xpoint,
  get_xpointview,
  get_paymentlist,
  post_paymentrefund,
  get_bannerlist,
  post_bannerwrite,
};
